import {TransferTableActionType} from 'notebook/transfer-tables/TransferTableActions';
import {TransferOperation, TransferOperationList} from 'notebook/transfer-tables/TransferTableConstants';
import {BenchlingAction} from 'redux-stores/Action';

export interface TransferTableModelsState {
  transferOperationListsById: {[id: string]: TransferOperationList};
  transferOperationsById: {[id: string]: TransferOperation};
}

export const TRANSFER_TABLE_MODELS_INITIAL_STATE = {
  transferOperationListsById: {},
  transferOperationsById: {},
};

export default function reduceTransferTableModels(
  state: TransferTableModelsState = TRANSFER_TABLE_MODELS_INITIAL_STATE,
  action: BenchlingAction
): TransferTableModelsState {
  switch (action.type) {
    case TransferTableActionType.TRANSFER_OPERATION_LISTS_FETCH_COMPLETED: {
      const {transferOperationListsById, transferOperationsById} = action;
      return {
        ...state,
        transferOperationListsById: {
          ...state.transferOperationListsById,
          ...transferOperationListsById,
        },
        transferOperationsById: {
          ...state.transferOperationsById,
          ...transferOperationsById,
        },
      };
    }
    default:
      return state;
  }
}
